module.exports = __webpack_public_path__ + "img/book_ribbon.b5c26b2d.svg";